function filterShopifyEvent(event, domElement, callback) {
    let executeCallback = false;
    if (event.type.includes('shopify:section')) {
        if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) executeCallback = true
    } else if (event.type.includes('shopify:block') && event.target === domElement) { 
        executeCallback = true 
    }
    if (executeCallback) callback(event)
}

// is in viewport
function inViewport(elem, callback, options = {}) {
    return new IntersectionObserver(entries => {
        entries.forEach(entry => callback(entry))
    }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function(arg) { 
    document.body.classList.toggle(arg);
}
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// first we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => { const roundedVh = Math.round(window.innerHeight * 0.01); document.body.style.setProperty('--vh', `${roundedVh}px`) };
window.addEventListener('resize', getSetVh);

// Browser check
function getNavigator() {
    const isiOS = navigator.userAgent.match(/(iPhone|iPad|iPod)/) && navigator.userAgent.match(/AppleWebKit/) && !navigator.userAgent.match(/CriOS/);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) || navigator.userAgent.indexOf('Chrome') != -1;
    const isFirefox = typeof InstallTrigger !== 'undefined' || navigator.userAgent.indexOf('Firefox') != -1;
    const isEdge = !!window.StyleMedia || navigator.userAgent.indexOf('Edge') != -1

    if (isiOS) document.documentElement.classList.add('ios');
    if (isSafari) document.documentElement.classList.add('safari');
    if (isChrome) document.documentElement.classList.add('chrome');
    if (isFirefox) document.documentElement.classList.add('firefox');
    if (isEdge) document.documentElement.classList.add('edge');
}

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        document.querySelectorAll(qSelectors).forEach(e => e.addEventListener('click', () => toggleBodyClass(bodyClass)))
    }
// Menu
    let toggleMenu = function() { 
        toggleClass('.fire-menu, .shrink-menu', 'open-menu')
    }


    function initializeDetailsControls() {
        // Handle dropdown menu
        const detailsElementsLv1 = document.querySelectorAll('details.lv1');
        const detailsElementsClosex = [...document.querySelectorAll('details.closex')];
    
        function closeOtherDetails(element) {
            const detailsOpened = document.querySelectorAll('details[open].lv1');
            for (const item of detailsOpened) {
                if (element !== item) {
                    item.removeAttribute('open');
                }
            }
        }

        function closeAllDetailsExcept(target) {
            detailsElementsClosex.forEach(f => !f.contains(target) ? f.removeAttribute('open') : '');
            a11yDetails();
        }
    
        function closeAllDetails() {
            detailsElementsClosex.forEach(f => f.removeAttribute('open'));
            a11yDetails();
        }
    
        // Dropdown menu
        detailsElementsLv1.forEach(item => {
            item.addEventListener('click', function() {
                closeOtherDetails(this);
            });
        });
    
        // Close details when clicked outside
        document.addEventListener('click', function(e) {
            if (!detailsElementsClosex.some(f => f.contains(e.target))) {
                closeAllDetails();
            } else {
                closeAllDetailsExcept(e.target);
            }
        });
    
        // Close details with esc key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                closeAllDetails();
            }
        });
    
        // Initial accessibility settings
        a11yDetails();
    }

    function a11yDetails() {
        document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
            summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
            
            if(summary.nextElementSibling.getAttribute('id')) {
                summary.setAttribute('aria-controls', summary.nextElementSibling.id);
            }
            
            summary.addEventListener('click', (event) => {
                event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
            });
        });
    }
    

// update button price on variant change 
function updatePrice(obj,idd) {
    var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
    var pb = document.querySelector('.uprice'+idd);
    pb.innerHTML = uid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd) }

// Debug
if (window.location.href.includes('debug')) {
    const OpenThinking = { theme: { name: 'Bullet', version: window.BOOMR.themeVersion } };
    const tsiCheck = (Shopify.theme.theme_store_id === null || Shopify.theme.theme_store_id === '') ? '❌' : '✅';
    console.log(`${tsiCheck} ${OpenThinking.theme.name} v${OpenThinking.theme.version} - ${Shopify.shop}`);
    alert(`${tsiCheck} ${OpenThinking.theme.name} v${OpenThinking.theme.version} `);
}

// Bullet marquee
if (!customElements.get('bullet-marquee')) customElements.define('bullet-marquee', class bulletMarquee extends HTMLElement {
    constructor() { super(); if (window.ResizeObserver) new ResizeObserver(this.duration.bind(this)).observe(this); }

    duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute('bullet-speed') || 5);
        const contentWidth = entries[0].contentRect.width;
      
        // Calculate the slowFactor based on content width
        let slowFactor = contentWidth <= 375 ? 1 : contentWidth >= 1280 ? 3 : 1 + (contentWidth - 375) / (1280 - 375);

        // Calculate the scrolling speed with the adjusted slowFactor
        const scrollingDuration = (scrollingSpeed * slowFactor * entries[0].target.querySelector('span').clientWidth / contentWidth).toFixed(3);

        this.style.setProperty('--bullet-speed', `${scrollingDuration}s`);
    }
});

/*** init app */
function app() {
    getSetVh(); // get Viewport Height
    getNavigator(); // get the browser + OS
    toggleMenu(); // toggle Menu
    initializeDetailsControls(); // call details 
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { app() })

/* -  ---------------------------------------------------- custom js codes - added by SF -------------------------------------  - */



// custom section js
 document.addEventListener('scroll', function() {
    const section = document.querySelector('.yuhm-scroll-banner-sticky');
    const logoContainer = document.querySelector('.yuhm-scroll-banner-logo-container');
   const logoContainer2 = document.querySelector('.yuhm-scroll-banner-logo-container2');
    const banners = document.querySelectorAll('.yuhm-scroll-banner');

    const sectionTop = section.offsetTop;
    const sectionHeight = section.offsetHeight;
    const scrollPosition = window.scrollY + window.innerHeight;

    // Logo stickiness logic
    if (scrollPosition >= sectionTop && scrollPosition <= sectionTop + sectionHeight) {
      logoContainer.style.position = 'fixed';
      logoContainer.style.bottom = '50px';
    } else {
      logoContainer.style.position = 'absolute';
      logoContainer.style.bottom = '-150px';
      logoContainer2.style.display = 'block';
      logoContainer2.style.opacity = '1';
      logoContainer2.style.animation = 'slideUpp 1.5s ease-out forwards';
    }

    // Parallax effect with controlled offset within viewport
    banners.forEach((banner) => {
      const speed = 0.15; // Reduced parallax speed for subtle effect
      const bannerTop = banner.getBoundingClientRect().top;
      const bannerHeight = banner.offsetHeight;
      
      if (bannerTop < window.innerHeight && bannerTop > -bannerHeight) {
        const offset = bannerTop * speed;
        banner.style.transform = `translateY(${offset}px)`;
      } else {
        banner.style.transform = 'translateY(0)';
      }
    });
  });



document.addEventListener("DOMContentLoaded", function () {
    let lastScrollTop = 0;
    const header = document.querySelector("#header"); // Adjust selector as needed

    window.addEventListener("scroll", function () {
        const currentScroll = window.pageYOffset;

        if (currentScroll > lastScrollTop) {
            // header.classList.remove("slide-down");
            // header.classList.add("slide-up");
        } else if (currentScroll < lastScrollTop) {
            // header.classList.remove("slide-up");
            // header.classList.add("slide-down");
        }
        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Prevent negative scroll values
    });
});



document.addEventListener("DOMContentLoaded", function() {
  // Select all tab links and panel containers
  const tabs = document.querySelectorAll('.mobh-tab');
  const panels = document.querySelectorAll('.mobh-panel');

  // Handle click event on each tab link
  tabs.forEach(tab => {
    tab.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default link behavior (scrolling)

      // Remove active classes from all tabs and panels
      tabs.forEach(t => t.classList.remove('is-active'));
      panels.forEach(p => p.classList.remove('is-active'));

      // Add active class to clicked tab and its corresponding panel
      tab.classList.add('is-active');
      const panelId = tab.getAttribute('href').substring(1); // Get the ID of the panel (remove '#')
      const panel = document.getElementById(panelId);
      if (panel) {
        panel.classList.add('is-active');
      }
    });
  });

  // Optionally, set the default tab to the first one
  if (tabs.length > 0) {
    tabs[0].classList.add('is-active');
    panels[0].classList.add('is-active');
  }
});



// iconic section code
    // Select the first and second divs
const firstDiv = document.querySelector('#shopify-section-template--15957223604342__gs_image_text_K9qC3B');
const secondDiv = document.querySelector('#shopify-section-template--15957223604342__gs_html_JNreRF');
// const firstDivls = document.querySelector('#shopify-section-template--15957223604342__gs_hero_double_CBmKkn');
// const secondDivls = document.querySelector('#shopify-section-template--15957223604342__gs_html_HcH7b8');
window.addEventListener('load', () => {
  secondDiv.classList.add('iconic-fixed');
  secondDivls.classList.add('iconic-fixed');
});
// Function to check if the first div is out of the viewport
function checkScroll() {
  const rect = firstDiv.getBoundingClientRect();
  // const rect2 = firstDivls.getBoundingClientRect();
  // If the first div is scrolled out of the viewport
  if (rect.bottom < 0) {
    secondDiv.classList.remove('iconic-fixed');
    firstDiv.classList.remove('iconic-mb100vh');
    secondDiv.classList.add('iconic-fixed-opp');
    // secondDiv.style.position = 'relative';
    // Replace 'your-class' with the class you want to remove
  }
  else{
    secondDiv.classList.add('iconic-fixed');
    firstDiv.classList.add('iconic-mb100vh');
    secondDiv.classList.remove('iconic-fixed-opp');
  }
  // if (rect2.bottom < 0) {
  //   secondDivls.classList.remove('iconic-fixed');
  //   firstDivls.classList.remove('iconic-mb100vh');
  //   secondDivls.classList.add('iconic-fixed-opp');
  //   // secondDiv.style.position = 'relative';
  //   // Replace 'your-class' with the class you want to remove
  // }
  // else{
  //   secondDivls.classList.add('iconic-fixed');
  //   firstDivls.classList.add('iconic-mb100vh');
  //   secondDivls.classList.remove('iconic-fixed-opp');
  // }
}

// Listen for the scroll event
window.addEventListener('scroll', checkScroll);